import { REPORT_PROP } from '../../../../constants/generalConstants';

export const TABLE_HEADER_REPORT_PROPS = [
    REPORT_PROP.YEAR,
    REPORT_PROP.PERIOD,
    REPORT_PROP.VERSION,
    REPORT_PROP.FORMAT,
] as const;
